import services from './../../services/service'; // Service Class
import SideScripts from './../Sidebar/script.js'; //Script call

let service = new services();

export default {
  name: "MainHeader",
  mixins: [SideScripts],
  data() {
      return {
          user: '', 
          user_slug: {}
      }
  },
  methods: {
    getPrompts(){
        //--forum-prompts
        let prompt = "cn_fo_prompt";
        let prompter = "#prompt-forum";
        let promt_value = 0;
        let prompt_timer = 0;
        //check/get ini forum-prompt
        //--if-forum-prompt-is-not-set-/-or-if-timer-is-zero
        //-----if-timer-is-1-then-run-has-finished
        //
        if(localStorage.getItem(prompt)){
            //is active
            let timer = localStorage.getItem(prompt);
            if((timer == 0) || (timer == 1)){ //0-notset//1-has-finished-run
                //---set-ini-run
                promt_value = 2;
                prompt_timer = 0;
            }else if(timer == 2){ //-first prompt set
                //--reset-timer
                promt_value = 3;
                prompt_timer = 8000;
            }else if(timer == 3){ //-2nd prompt set
                //--reset-timer
                promt_value = 4;
                prompt_timer = 32000;
            }else if(timer == 4){ //-3rd prompt set
                //--reset-timer
                promt_value = 1;
                prompt_timer = 82000;
            }
        }else{ //not active
            //---set-ini-run
            promt_value = 2;
            prompt_timer = 0;
        }
        //set
        if(this.checkCanSetPrompt(prompt)){ console.log('888')
            this.setPrompts(prompt,promt_value,prompter,prompt_timer);
        }
    },

    checkCanSetPrompt(prompt){
        let can_set = false;
        if(prompt == 'forum'){
            //
        }
        //
        // return can_set;
        return true;
    },


    setPrompts(prompt,value,prompter,timer){
        if(value > 0){
            localStorage.setItem(prompt, value);
        }
        //
        if(timer > 0){
            setTimeout(function (){
                $(prompter).modal();
            }, timer);
        }
    },

  },
  created: function() {
    // setTimeout(function (){console.log(992)
    //     $("#prompt-forum").modal();
    // }, 2000);
    //--Test
   
    //this.getPrompts();
  }
}


// WEBPACK FOOTER //
// ./src/components/YPrompts/script.js